import { useCallback } from 'react';
import { TravelPremiumRisk } from '@app/domain/model/eshop/travel/TravelPremiumRisk';
import { trackAddToCart } from '@app/infrastructure/gtm/travel/trackAddToCart';
import { TRAVEL_INSURANCE_STEPS } from '@app/app/esales/travel/_sections/steps/TRAVEL_INSURANCE_STEPS';

interface UseTravelGtmTrackingParams {
    selectedRisks: TravelPremiumRisk[];
}

interface TrackStepCompletionParams {
    currentStepKey: string;
}

export function useTravelGtmTracking({ selectedRisks }: UseTravelGtmTrackingParams) {
    const trackStepCompletion = useCallback(
        ({ currentStepKey }: TrackStepCompletionParams) => {
            if (currentStepKey !== TRAVEL_INSURANCE_STEPS.CHOOSE_INSURANCE) {
                return;
            }

            trackAddToCart(selectedRisks);
        },
        [selectedRisks],
    );

    return {
        trackStepCompletion,
    };
}
